import { render } from "./AdminLeaveReport.vue?vue&type=template&id=58e7ac3d"
import script from "./AdminLeaveReport.vue?vue&type=script&lang=js"
export * from "./AdminLeaveReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__